'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { rotaProcessoPorOrigem } from '@/features/encerramento-processo';
import { useCertificadoAcessosPage } from '../../hooks/useCertificadoAcessosPage';
import type { OrigemCertificadoAcessos } from '../../types/certificadoAcessosTypes';
import { CertificadoAcessosView } from './CertificadoAcessosView';
interface CertificadoAcessosPageContainerProps {
  processoId: string;
  origem?: OrigemCertificadoAcessos;
}
export function CertificadoAcessosPageContainer(t0) {
  const $ = _c(11);
  const {
    processoId,
    origem: t1
  } = t0;
  const origem = t1 === undefined ? "parte" : t1;
  const router = useRouter();
  const {
    certificado,
    isLoading,
    error,
    isDownloadingPdf,
    baixarPdf
  } = useCertificadoAcessosPage(processoId, origem);
  let t2;
  if ($[0] !== origem || $[1] !== processoId || $[2] !== router) {
    t2 = () => {
      if (typeof window !== "undefined" && window.history.length > 1) {
        router.back();
        return;
      }
      router.push(rotaProcessoPorOrigem(origem, processoId));
    };
    $[0] = origem;
    $[1] = processoId;
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleVoltar = t2;
  let t3;
  if ($[4] !== baixarPdf || $[5] !== certificado || $[6] !== error || $[7] !== handleVoltar || $[8] !== isDownloadingPdf || $[9] !== isLoading) {
    t3 = <CertificadoAcessosView certificado={certificado} isLoading={isLoading} error={error} isDownloadingPdf={isDownloadingPdf} onBaixarPdf={baixarPdf} onVoltar={handleVoltar} />;
    $[4] = baixarPdf;
    $[5] = certificado;
    $[6] = error;
    $[7] = handleVoltar;
    $[8] = isDownloadingPdf;
    $[9] = isLoading;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}